import { handleKeys } from '../caseDetails'
import { getConditionalKeys } from '../caseDetails/getConditionalKeys'
import { getCaseDetailKeys } from '../caseDetails/getCaseDetailKeys'
import type { TinyMCEData, TinyMCEMenuTemplate } from 'types/editor'

export const insertableCaseDetails = (editorProps: TinyMCEData) => {
  const { caseDetails } = editorProps
  if (!caseDetails) return

  const insertableCaseDetails: TinyMCEMenuTemplate[] = []

  const caseDetailsKeys = getCaseDetailKeys(caseDetails)

  const conditionalKeys = getConditionalKeys(caseDetails)

  const allKeys = Array.from(new Set([...caseDetailsKeys, ...conditionalKeys]))

  allKeys.forEach((key) =>
    handleKeys(
      editorProps.editor,
      editorProps.caseDetails,
      key,
      insertableCaseDetails,
      editorProps.dateFormat,
      editorProps.selectedTheme,
      editorProps.pageSetLocale,
    ),
  )

  return insertableCaseDetails
}
